import {
	DriftWalletName,
	DRIFT_CUSTOM_WALLET_OPTIONS,
	DRIFT_CUSTOM_WALLET_ICONS,
} from 'src/constants/wallets';
import { WALLET_BUTTON_ICON_CLASSNAME } from './WalletButton';
import ConnectWalletModalButton from 'src/components/Modals/Onboarding/ConnectWalletModal/ConnectWalletModalButton';

export const MagicLinkButton = (props: {
	onChooseWallet: (walletName: DriftWalletName) => void;
}) => {
	return (
		<ConnectWalletModalButton
			onClick={() =>
				props.onChooseWallet(
					DRIFT_CUSTOM_WALLET_OPTIONS.MAGIC_AUTH_WALLET_ADAPTER_NAME
				)
			}
		>
			<div className={WALLET_BUTTON_ICON_CLASSNAME}>
				<img
					src={DRIFT_CUSTOM_WALLET_ICONS.MAGIC_AUTH_WALLET_ADAPTER}
					className="size-full"
				/>
			</div>
			<span>Email via Magic Link</span>
		</ConnectWalletModalButton>
	);
};
